/* eslint-disable import/no-cycle */
import axiosInstance from "apis/axiosInstance";

export const configurationApi = {
    post: async (path, params, cancelToken) =>
      axiosInstance
        .post(`/configuration${path}`, params, {
          cancelToken: cancelToken?.token,
        })
        .then((res) => {
          if (res?.data?.error) throw res.data;
          return res?.data;
        })
        .catch((err) => {
          console.log("🔴 Raw error:", err);
  
          // If server returned a proper response (even with error status)
          if (err.response && err.response.data) {
            throw err.response.data; // <-- real error from backend
          }
  
          // Network or CORS issue (or server crash without response)
          if (err.message === "Network Error") {
            throw {
              message: "Network Error (possibly due to invalid response, CORS, or crash)",
              status: 503,
            };
          }
  
          // Fallback (e.g., other unexpected error)
          throw {
            message: err.message || "Unknown error",
            status: err.status || 500,
          };
        }),
  
    get: async (path, params, cancelToken) =>
      axiosInstance
        .get(`/configuration${path}`, {
          params,
          cancelToken: cancelToken?.token,
        })
        .then((res) => {
          if (res?.data?.error) throw res.data;
          return res?.data;
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            throw err.response.data;
          }
          throw {
            message: err.message || "Unknown GET error",
            status: err.status || 500,
          };
        }),
  };
  

//Checklist
export const getLKEvents = async () => configurationApi.get('/getEvents');
export const getLKSeason = async () => configurationApi.get('/getSeason');
export const getApplicationTypeProductAges = async () => configurationApi.get('/getApplicationTypeProductAges');
export const getApplicationTypeProductServices = async () => configurationApi.get('/getApplicationTypeProductServices');
export const getFileTypes = async () => configurationApi.get('/getFileTypes');
export const getApplicationType = async () => configurationApi.get('/getApplicationType');
export const getOptionalAnswers = async () => configurationApi.get('/getOptionalAnswer');
export const getQuestion = async () => configurationApi.get('/getQuestion');
export const postSeason = async (params) => configurationApi.post('/postSeason', params);
export const postEvents = async (params) => configurationApi.post('/postEvents', params);
export const postApplicationType = async (params) => configurationApi.post('/postApplicationType', params);
export const postApplicationTypeProductAges = async (params) => configurationApi.post('/postApplicationTypeProductAges', params);
export const postApplicationTypeProductServices = async (params) => configurationApi.post('/postApplicationTypeProductServices', params);
export const postFileTypes = async (params) => configurationApi.post('/postFileTypes', params);
export const getDisciplines = async () => configurationApi.get('/getDisciplines');
export const postOptionalAnswers = async (params) => configurationApi.post('/postOptionalAnswer', params);
export const postQuestion = async (params) => configurationApi.post('/postQuestion', params);
export const getQuestionTypes = async () => configurationApi.get('/getQuestionTypes');
export const getProductServices = async () => configurationApi.get('/getProductServices');
export const getTransactionTypes = async () => configurationApi.get('/getTransactionTypes');



//Event Categories
export const getEventCategories = async () => configurationApi.get('/getEventCategories');
export const postEventCategories = async (params) => configurationApi.post('/postEventCategories', params);